export class WinPresentationViewEvents {
    public static readonly INITIAL_ANIMATION_STARTED: string = 'INITIAL_ANIMATION_STARTED';
    public static readonly PAY_ANIMATION_STARTED: string = 'PAY_ANIMATION_STARTED';
    public static readonly INITIAL_ANIMATION_FINISHED: string = 'INITIAL_ANIMATION_FINISHED';
    public static readonly INITIAL_ANIMATION_FREESPINS_FINISHED: string = 'INITIAL_ANIMATION_FREESPINS_FINISHED';
    public static readonly ALL_PAY_ANIMATIONS_FINISHED: string = 'ALL_PAY_ANIMATIONS_FINISHED';
}
